<template>
  <q-dialog
    v-model="open"
    persistent
    transition-show="fade"
    transition-hide="fade"
    position="top"
  >
    <q-card style="width: 100vw;max-width: 80vw; top: 7rem;">
      <q-toolbar>
        <q-toolbar-title class="text-h6">
          Filtered Dispatches
        </q-toolbar-title>
        <q-btn flat round dense icon="close" @click="(e) => closeDialog()" />
      </q-toolbar>

      <q-card-section class="q-py-none">
        <q-table
            flat
            bordered
            :data="loading ? [] : (quotes || [])"
            :columns="columns"
            :loading="loading"
            table-class="quotes-table"
        >

        <template v-slot:body="props">
          <q-tr :props="props" :class="oddRowBgObject(props.rowIndex)">
            <q-td key="id" :props="props">
              <q-btn
                color="primary"
                outline
                :label="props.row.id"
                padding="10px"
                :href="`/'orders'/${
                  props.row.id
                }?edit=true`"
              />
            </q-td>

            <q-td key="status" :props="props">
              <p class="q-ma-none">
                {{ props.row.parentStatus ? props.row.parentStatus.name : '' }}
              </p>
            </q-td>

            <q-td key="date" :props="props">
              <p class="text-bold q-ma-none">
                {{ props.row.transport.availableDate | usDateFormat }}
              </p>
            </q-td>
            <q-td key="price" :props="props">
              <app-quote-price :data="props.row" />
            </q-td>
            <q-td key="shipper" :props="props">
              <app-quote-shipper :data="props.row" />
            </q-td>
            <q-td key="vehicle" :props="props">
              <app-quote-vehicle :data="props.row" />
            </q-td>
            <q-td key="origin" :props="props">
              <app-quote-origin :data="props.row" />
            </q-td>
            <q-td key="destination" :props="props">
              <app-quote-destination :data="props.row" />
            </q-td>
            <q-td key="engagements" :props="props">
              <span
                v-for="(engagement, index) in QUOTE_ENGAGEMENTS"
                :key="index"
              >
                <q-icon
                  :name="engagement.icon"
                  color="negative"
                  size="sm"
                  v-if="
                    props.row.engagements &&
                    props.row.engagements.includes(engagement.value)
                  "
                />
              </span>
            </q-td>
            <q-td key="options" :props="props">
              <div class="row q-gutter-x-sm">

                <q-btn
                  dense
                  size="sm"
                  outline
                  color="secondary"
                  icon="visibility"
                  :to="{
                    name: 'order-detail',
                    params: { id: props.row.id }
                  }"
                />
              </div>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      </q-card-section>
      <q-card-actions>
        <q-btn
          flat
          label="Close"
          color="primary"
          @click="(e) => closeDialog()"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>
import graphql from '@client/graphql';

import {
  QUOTE_ENGAGEMENTS
} from '@server/constants';

import AppQuoteShipper from '@client/pages/quotes/partials/shipper';
import AppQuoteVehicle from '@client/pages/quotes/partials/vehicle';
import AppQuoteOrigin from '@client/pages/quotes/partials/origin';
import AppQuotePrice from '@client/pages/quotes/partials/price';
import AppQuoteDestination from '@client/pages/quotes/partials/destination';

export default {
  name: 'FilteredDispatches',
  components: {
    AppQuoteShipper,
    AppQuoteVehicle,
    AppQuoteOrigin,
    AppQuoteDestination,
    AppQuotePrice
  },
  apollo: {
    quotes() {
      return {
        query() {
          if (this.referrerId) {
            return graphql.queries.getDispatchesReportByReferrer;
          }
            return graphql.queries.getDispatchesReportByUser;
        },
        variables() {
          const variables = {
            dateRangeStart: this.dateRangeStart,
            dateRangeEnd: this.dateRangeEnd
          };

          if (this.referrerId) {
            variables.referrerId = this.referrerId;
          } else {
            variables.userId = this.userId;
          }

          return variables;
        },
        skip() {
          return !this.queryReady;
        },
        watchLoading(isLoading) {
          this.loading = isLoading;
        },
        error(error) {
          this.error = error;
        },
        update(data) {
          if (this.referrerId) {
            return data.dispatchesReportByReferrer;
          }
            return data.dispatchesReportByUser;
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      };
    }
  },
  data() {
    let columns = [
      {
        name: 'id',
        label: 'Order ID',
        align: 'left',
        sortable: true
      },
      {
        name: 'status',
        label: 'Status',
        align: 'center'
      }
    ];

    columns.push({
    name: 'date',
    label: 'Ship Date',
    align: 'left',
    sortable: true
    });

    columns = columns.concat([
      {
        name: 'price',
        label: 'Price',
        align: 'center'
      },
      {
        name: 'shipper',
        label: 'Shipper',
        align: 'center'
      },
      {
        name: 'vehicle',
        label: 'Vehicle',
        align: 'center'
      },
      {
        name: 'origin',
        label: 'Origin',
        align: 'center'
      },
      {
        name: 'destination',
        label: 'Destination',
        align: 'center'
      },

      {
        name: 'engagements',
        label: 'Engagements',
        align: 'left'
      },
      {
        name: 'options',
        label: '',
        align: 'center'
      }
    ]);

    return {
        open: false,
        queryReady: false,

        loading: false,
        error: null,
        errors: [],

        QUOTE_ENGAGEMENTS,

        referrerId: null,
        userId: null,
        dateRangeStart: null,
        dateRangeEnd: null,

        columns
    };
  },
  methods: {
    openDialog(filters = {}) {
      this.referrerId = filters.referrerId;
      this.userId = filters.assigneeId;
      this.dateRangeStart = filters.dateRangeStart;
      this.dateRangeEnd = filters.dateRangeEnd;
      this.open = true;
      this.queryReady = true;
    },
    closeDialog() {
      this.open = false;
    },
    oddRowBgObject(index) {
      const bg = {
        'bg-grey-9': false,
        'bg-grey-12': false
      };

      if ((index + 1) % 2) {
        if (document.body.classList.contains('body--dark')) {
          bg['bg-grey-9'] = true;
        } else {
          bg['bg-grey-12'] = true;
        }
      }
      return bg;
    }
  }
};
</script>
<style lang="scss"></style>
